<template>
  <div v-if="event" :idfoevent="event.idfoevent.toString()" class="simple-event-component outright-event-component clearfix">
    <div v-if="isDebug" class="debug">
      idfoevent {{ event.idfoevent }} <br />
      eventdisplayorder {{ event.eventdisplayorder }}<br />
      eventrows {{ event.eventrows }}
    </div>

    <div class="flex-row" v-if="event.idfobolifestate === 'O'">
      <div class="event-info" >
        <cdu-info-head :event="event"></cdu-info-head>
      </div>
      <outrightMarket v-if="event.idfobolifestate === 'O' && event.outrightMarket" class="markets-container" :event="event"></outrightMarket>
    </div>

  </div>
</template>
<script>
  import outrightMarket from '@/components/bettingoffer/outrightMarket'
  import CduInfoHead from '@/components/cdu/cduInfoHead'

  import Brands from '@/components/mixins/Brands'
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Icon from '@/components/common/Icon'

  export default {
    name: 'outrightEvent',

    props: [
      'event',
      'showheader',
      'headertype'
    ],

    components: {
      CduInfoHead,
      outrightMarket,
      Icon
    },

    mixins: [
      Brands,
      BettingOffer
    ],

    computed: {
      isDateTomorrow () {
        return this.isTomorrow
      },
      isDateToday () {
        return this.isToday
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .prematch
    .simple-event-component
      table
        width 30%
        float left
</style>



// WEBPACK FOOTER //
// src/components/bettingoffer/outrightEvent.vue